import { useEffect } from 'react'
import { getCurPlayer } from '@/services/player'
import { Me } from '@/services/types/player'
import user from '@/stores/user'
import { useLocation } from 'react-router-dom'
// import store from 'store'

const useMe = () => {
  const whitePath = ['/download']
  const { pathname } = useLocation()

  useEffect(() => {
    !whitePath.includes(pathname) && fetchUser()
  }, [])

  const fetchUser = async () => {
    try {
      const res = (await getCurPlayer()) as unknown as Me
      const player = { ...res, name: res.nickName }
      user.userPlayer = player

      // 长效化，咱不需要
      // const userPlayerOld = store.get('userPlayer')
      // if (!userPlayerOld || JSON.stringify(userPlayerOld) !== JSON.stringify(player)) {
      //   // 新用户登录/其他用户登录
      //   store.set('userPlayer', player)
      //   store.set('curPlayer', player)
      //   user.curPlayer = player
      // } else {
      //   // 同一用户登录
      //   if (user.curPlayer.playerId) {
      //   } else if (store.get('curPlayer')) {
      //     user.curPlayer = store.get('curPlayer')
      //   } else {
      //     store.set('curPlayer', player)
      //     user.curPlayer = player
      //   }
      // }
      user.curPlayer = player
    } catch (error) {
      // store.set('userPlayer', DefautlUser)
      // store.set('curPlayer', DefautlUser)
      user.reset()
    }
  }
}
export default useMe
